module.exports = __webpack_public_path__ + "img/traceVideo.b624c3a0.jpg";